import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next) // 리액트에 i18next를 연결합니다.
  .init({
    resources: {
      ko: {
        translation: {
          AniTitleSub: " AI 온라인 반려동물 스튜디오",
          AniTitleDesc_1: "내 반려동물의",
          AniTitleDesc_2: "다양한 스펙트럼,",
          AniTitleDesc_3: "스펫트럼",
          AniTitleImg_1: "/assets/images/AppStore_Download.svg",
          AniTitleImg_2: "/assets/images/PlayStore_Download.svg",
          AniTitleImg_3: "/assets/images/IR_Deck_Download.svg",
          IR_Deck_Link: "https://drive.google.com/file/d/1BPFaha4m4jpEmvaQgmxhOcuUDcjwVxun/view?usp=sharing",
          AniImgTitle_1: "우주를 유영하는",
          AniImgTitle_2: "뉴스를 진행하는",
          AniImgTitle_3: "모험을 떠나는",
          AniImgTitle_4:
            "내 반려동물의 <strong>상상하지 못했던</strong> 스펙트럼",
          fade__another_title: "숨겨진 또다른 모습",
          fade__another_content_1:
            "아름다움을 숨기고 있는 빛은 프리즘에 부딪히고 나서야",
          fade__another_content_2: "무지개빛",
          fade__another_content_3: "을 드러냅니다.",
          fade__another_content_4: "우리는 이를",
          fade__another_content_5: "스펙트럼",
          fade__another_content_6: "이라고 부릅니다.",
          fade__another_content_7:
            "만약 사랑하는 나의 반려동물도 아름다운 스펙트럼을 숨기고 있다면?",
          fade__another_content_8: "나의 반려동물의 스펙트럼. 스펫트럼",
          fade__another_content_9: "이 해답이 될 것입니다!",
          fade__another_content_10:
            "특별한 그림체가 되거나, 멋진 신사가 된다거나, 물 속에 있는 모습까지.",
          fade__another_content_11: "반려동물에 특화된 SPETTRUM AI 기술을 통해",
          fade__another_content_12:
            "내 반려동물 사진을 통해 숨겨진 또다른 모습을 만나보세요.",
          model__upper_title_1: "모델.",
          model__upper_title_2: "",
          model__upper_title_3: "상상 ",
          model__upper_title_4: "그 이상.",
          model__upper_content_1:
            " 10장의 내 반려동물 사진을 준비하여 모델을 만들어 보세요.",
          model__upper_content_2:
            "모델에 컨셉을 적용하여 상상 속에서 가능했던 모습을 확인하세요.",
          moment_content_1: "순간을 넘어선",
          moment_content_2: " 새로운 모습의 사진",
          moment_content_3: "을 만들어 보세요.",
          moment_content_4:
            "10장의 반려동물 사진을 SPETTRUM이 학습하여 보다 더 다채로운 모습을 선사합니다.",
          moment_content_5: "모델을 완성하여 보고싶은 모습의 컨셉을 선택하고",
          moment_content_6: "",
          moment_content_7: "볼 수 없었던 표정, 몸짓, 모습",
          moment_content_8: "을 만나보세요.",
          model__create_content_1: "최대",
          model__create_content_2: "분",
          model__create_content_3: "모델 생성",
          model__create_content_4: "장",
          model__create_content_5: "모델 생성에 필요한 사진",
          model__create_content_6:
            "모델은 SPETTRUM AI에 나의 반려동물을 학습하여 더욱 다양하고 새로운 모습을 생성하는 방법입니다.",
          model__create_content_7: " 15~20장의 내 반려동물의 사진",
          model__create_content_8:
            "을 제공하여 모델을 생성할 수 있죠. 언제 어디서든 변화할 수 있는 내 반려동물 모델을 준비하세요.",
          model__picture_content_1: "최대",
          model__picture_content_2: "초",
          model__picture_content_3: "모델 사진 생성",
          model__picture_content_4: "학습된 모델은",
          model__picture_content_5: " 수 많은 컨셉",
          model__picture_content_6:
            "으로 표현할 수 있게 되어 무궁무진한 모습을 가능하게 합니다. 내 반려동물의 볼 수 없었던 모습을 간직하세요.",
          filter__funny_title_1: "필터",
          filter__funny_title_2: "더욱 재밌게.",
          filter__funny_content_1: "한 장의 반려동물 사진을",
          filter__funny_content_2:
            " 쉽고 빠르게 재미있는 사진으로 만들어 보세요.",
          filter__moment_content_1: "사진 속 순간을",
          filter__moment_content_2: " 더욱 재미있게",
          filter__moment_content_3: " 바꾸어 보세요.",
          filter__moment_content_4:
            "색다른 컨셉을 골라 마음에 드는 순간으로 바꿔 볼 수 있죠..",
          filter__moment_content_5: "여러분들의 재치있는 솜씨를 통해",
          filter__moment_content_6: " 특별해진 순간",
          filter__moment_content_7: "을 간직하세요.",
          filter__create_content_1: "최대",
          filter__create_content_2: "초",
          filter__create_content_3: "필터 사진",
          filter__create_content_4: " 생성 시간",
          filter__create_content_5: "장",
          filter__create_content_6: "필요한 사진",
          filter__create_content_7: "필터는",
          filter__create_content_8:
            " 한 장의 사진에 컨셉을 적용하여 새로운 사진을 만드는 방법",
          filter__create_content_9: "입니다.",
          filter__create_content_10:
            "먼저 내 반려동물 사진 한 장을 얼굴이 잘 나오도록 자른 후, SPETTRUM이 제공하는 다양한 컨셉 중 마음에 드는 것을 선택하세요. 내 반려동물의 사진이 선택한 컨셉으로 꾸며져 나타납니다.",
          concept__rainbow_title_1: "컨셉",
          concept__rainbow_title_2: "내 반려동물의",
          concept__rainbow_title_3: " 빨주노초파남보",
          concept__meet_concent_1: "수많은 컨셉",
          concept__meet_concent_2: "들을 만나고",
          concept__meet_concent_3: " 수없이 다양한 모습을 상상하세요.",
          concept__meet_concent_4: "SPETTRUM이 제공하는 다양한 컨셉을 통해",
          concept__meet_concent_5: "내 반려동물의 숨겨진 모습들을 꺼내보세요.",
          concept__meet_concent_6: "",
          concept__create_content_1: "장",
          concept__create_content_2: "사진 한 번 생성 시",
          concept__create_content_3:
            "SPETTRUM AI는 한 번 사진을 생성할 때 12장을 만들어 내며, 4장을 저장하게 됩니다.",
          concept__create_content_4: " 그 중에서",
          concept__create_content_5: " SPETTRUM이 추천하는 4장",
          concept__create_content_6: "을 받을수도, 또는 마음에 드는",
          concept__create_content_7: " 제일 간직하고 싶은 4장을 선택",
          concept__create_content_8:
            "하여 받을 수도 있죠. 원하는 방법을 선택하여 사진을 간직해 보세요.",
          footer__content_1: "CO. UNPEIL (언페일 컴퍼니)",
          footer__content_2: "회사 주소 :",
          footer__content_3:
            " 경상북도 구미시 대학로61, 산학협력관동 807-2호 (양호동,금오공과대학교)",
          footer__content_4: "대표 :",
          footer__content_5: " 서승우   |   ",
          footer__content_6: "대표 전화번호 :",
          footer__content_7: " +82 10 - 7276 - 3717",
          footer__content_8: "이메일 :",
          footer__content_9: " seed@unpeil.com   |   ",
          footer__content_10: "사업자 등록번호 :",
          footer__content_11: " 799-11-02439",
          footer__content_12: "이용약관",
          footer__content_13: "개인정보 처리방침",
        },
      },
      en: {
        translation: {
          AniTitleSub: " ONLINE AI PET STUDIO",
          AniTitleDesc_1: "Companion’s",
          AniTitleDesc_2: "DIVERGING",
          AniTitleDesc_3: "Spectrum",
          AniTitleImg_1: "/assets/images/AppStore_Download_EN.svg",
          AniTitleImg_2: "/assets/images/PlayStore_Download_EN.svg",
          AniTitleImg_3: "/assets/images/IR_Deck_Download.svg",
          IR_Deck_Link: "https://drive.google.com/file/d/1vdZCNKtkQKFJ-_hAZLeaXX2wTxJ-LjDl/view?usp=sharing",
          AniImgTitle_1: "Spacewalking",
          AniImgTitle_2: "News reporting",
          AniImgTitle_3: "Adventuring",
          AniImgTitle_4: "Companion’s <strong>UNIMAGINABLE</strong> spectrum",
          fade__another_title: "Yet unseen Appearance",
          fade__another_content_1: "Only through a prism does light reveal its",
          fade__another_content_2: " rainbow",
          fade__another_content_3: " colors.",
          fade__another_content_4: "We call this prism. We call this a",
          fade__another_content_5: '"spectrum of light"',
          fade__another_content_6: "",
          fade__another_content_7:
            "Have you imagined your beloved pet hiding its beautiful spectrum?",
          fade__another_content_8: "SPETTRUM, spectrum of my pet",
          fade__another_content_9: ", is what you are looking for.",
          fade__another_content_10:
            "From unique drawing style, dashing gentleman to spacewalking",
          fade__another_content_11:
            "astronaut, discover your companion's unseen appearances through",
          fade__another_content_12: "SPETTRUM's pet-specialized AI technology.",
          model__upper_title_1: "Model.",
          model__upper_title_2: "Beyond",
          model__upper_title_3: " Imagination",
          model__upper_title_4: "",
          model__upper_content_1:
            "Prepare 20 photos of your pet and create a model. Choose a theme for the",
          model__upper_content_2:
            "model to discover appearances that are possible only in your imagination.",
          moment_content_1: "Make",
          moment_content_2: " photos of a new appearance",
          moment_content_3: " beyond the moment.",
          moment_content_4:
            "With just 20 photos of your companion, SPETTRUM provides even more diverse appearances.",
          moment_content_5:
            "Complete the model, choose the themes of the appearance you wish to see, ",
          moment_content_6: "and",
          moment_content_7:
            " discover expressions, gestures, and appearances you haven't seen before.",
          moment_content_8: "",
          model__create_content_1: "Maximum",
          model__create_content_2: "min",
          model__create_content_3: "for creating a model",
          model__create_content_4: "photos",
          model__create_content_5: "required for creating a model",
          model__create_content_6:
            "Model is a method for SPETTRUM AI to machine-learn your companion and create more diverse and new appearances. You can create a model by providing",
          model__create_content_7: " 15 to 20 photos of your companion.",
          model__create_content_8:
            " Create your companion model that can change anywhere, anytime.",
          model__picture_content_1: "Maximum",
          model__picture_content_2: "sec",
          model__picture_content_3: "for generating model photos",
          model__picture_content_4: "Trained models enable expression through",
          model__picture_content_5: " countless themes,",
          model__picture_content_6:
            " making infinite number of appearances possible. Keep the unseen looks of your companion.",
          filter__funny_title_1: "Filter",
          filter__funny_title_2: "Even more fun.",
          filter__funny_content_1: "Transform a single photo",
          filter__funny_content_2: "into a fun picture easily and quickly.",
          filter__moment_content_1:
            "Transform your moments with your companions into something",
          filter__moment_content_2: " even more enjoyable.",
          filter__moment_content_3: "",
          filter__moment_content_4:
            "Choose a unique themes and change it into a moment you love.",
          filter__moment_content_5: "Cherish the",
          filter__moment_content_6: " special moments",
          filter__moment_content_7: " enhanced by your creativity.",
          filter__create_content_1: "Maximum",
          filter__create_content_2: "sec",
          filter__create_content_3: "for generating",
          filter__create_content_4: " filter photo",
          filter__create_content_5: "photo",
          filter__create_content_6: "required",
          filter__create_content_7: "Filter photo",
          filter__create_content_8:
            " applies themes to a single photo to generate a new photo.",
          filter__create_content_9: "",
          filter__create_content_10:
            "After cropping companion's photo so that its face is clearly visible, choose a theme provided by SPETTRUM to apply to your beloved pet. The original photo will transform according to the chosen theme.",
          concept__rainbow_title_1: "Themes",
          concept__rainbow_title_2: "Companion’s",
          concept__rainbow_title_3: " Rainbow",
          concept__meet_concent_1: "Explore numerous themes",
          concept__meet_concent_2:
            " and imagine countless different appearances.",
          concept__meet_concent_3: "",
          concept__meet_concent_4: "",
          concept__meet_concent_5:
            "Uncover the hidden aspects of your companion,",
          concept__meet_concent_6:
            " through the various themes provided by SPETTRUM.",
          concept__create_content_1: "photos",
          concept__create_content_2: "pet generation",
          concept__create_content_3:
            "SPETTRUM AI generates 12 photos per purchase and saves 4 of them. You can either receive",
          concept__create_content_4: "",
          concept__create_content_5: " the 4 photos recommended by SPETTRUM",
          concept__create_content_6: " or",
          concept__create_content_7: " choose the ones you like the most.",
          concept__create_content_8: " Choose the method you prefer.",
          footer__content_1: "CO. UNPEIL.",
          footer__content_2: "HQ :",
          footer__content_3:
            " Kumoh National Institute of Technology, 61, Daehak-ro, Gumi-si, Gyeongsangbuk-do, Korea",
          footer__content_4: "CEO :",
          footer__content_5: " Seungwoo Seo   |   ",
          footer__content_6: "Mobile :",
          footer__content_7: " +82 10 - 7276 - 3717",
          footer__content_8: "E-mail :",
          footer__content_9: " seed@unpeil.com   |   ",
          footer__content_10: "Company Registration Number :",
          footer__content_11: " 799-11-02439",
          footer__content_12: "Terms of Use",
          footer__content_13: "Privacy Policy",
        },
      },
    },
    lng: "kor", // 기본 언어 설정
    fallbackLng: "en", // 언어가 지원되지 않을 때의 대체 언어 설정
    interpolation: {
      escapeValue: false, // 리액트는 HTML 태그도 렌더링할 수 있어서 false로 설정합니다.
    },
  });

export default i18n;
